import { Modal } from "@mui/material";
import { useState } from "react";
import Select from "react-select";
import Swal from "sweetalert2";

import { useDispatch } from "react-redux";
import { tipoClienteOptions } from "../../../../hook/Arreglos";
import { editarEmpresa } from "../../../../store/Empresa/thunkEmpresa";

export const ModalEditarEmpresa = ({ open, onClose, empresaDetails }) => {

       const [empresaData, setEmpresaData] = useState({
           nombre_empresa: empresaDetails.nombre_empresa,
           razon_social: empresaDetails.razon_social,
           cedula_juridica: empresaDetails.cedula_juridica,
           pagina_web: empresaDetails.pagina_web,
           telefono: empresaDetails.telefono,
           pais: empresaDetails.pais,
           direccion_fisica: empresaDetails.direccion_fisica,
           industria: empresaDetails.industria,
           tipo_cliente: empresaDetails.tipo_cliente,
           tiene_credito: empresaDetails.tiene_credito,
           notas_importantes: empresaDetails.notas_importantes,
           id_empresa: empresaDetails.id_empresa,
       });

       const [errors, setErrors] = useState({});

       const tieneCreditoOptions = [
           { value: "Si", label: "Sí" },
           { value: "No", label: "No" },
       ];

       const handleInputChange = ({ target: { name, value } }) => {
           setEmpresaData((prevData) => ({ ...prevData, [name]: value }));
           if (errors[name]) {
               setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
           }
       };

       const handleSelectChange = (option, { name }) => {
           setEmpresaData((prevData) => ({
               ...prevData,
               [name]: option ? option.value : "",
           }));
           if (errors[name]) {
               setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
           }
       };

       const validateFields = () => {
           const newErrors = {};
           Object.keys(empresaData).forEach((key) => {
               if (!empresaData[key] && key !== "logoEmpresa" && key !== "notas_importantes") {
                   newErrors[key] = "Este campo es obligatorio";
               }
           });
           return newErrors;
       };

       const dispatch = useDispatch();

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validateFields();

        if (Object.keys(validationErrors).length > 0) {
            // Set validation errors if any fields are missing or invalid
            setErrors(validationErrors);
            Swal.fire("Campos Obligatorios", "Todos los campos en rojo son obligatorios.", "warning");
        } else {
            Swal.fire({
                title: "¿Está seguro?",
                text: "¿Desea actualizar la información de la empresa con los datos ingresados?",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Sí, actualizar empresa",
                cancelButtonText: "Cancelar",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "Actualizando empresa",
                        text: "Por favor espere...",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        didOpen: () => Swal.showLoading(),
                    });

                    // Dispatches the action to edit the company with the provided data
                    await dispatch(editarEmpresa(empresaData));

                    Swal.fire({
                        icon: "success",
                        title: "Empresa actualizada",
                        text: "La información de la empresa ha sido actualizada exitosamente.",
                        confirmButtonText: "Aceptar",
                    }).then(() => {
                        // Closes the modal and refreshes the page
                        onClose();
                        window.location.reload();
                    });
                }
            });
        }
    };


    return (
        <Modal
            open={Boolean(open)}
            onClose={onClose}
            className="modal fade show"
            aria-labelledby="exampleModalLongTitle"
            style={{ display: "block", zIndex: 1050 }} // Ajuste del z-index
            aria-modal="true"
            role="dialog"
        >
            <div className="modal-dialog" role="document" style={{ maxWidth: "80%", margin: "1.75rem auto" }}>
                <div className="modal-content">
                    <div className="modal-body">
                        <p className="mb-0" style={{ fontSize: window.innerWidth < 600 ? "16px" : "28px" }}>
                            Editar empresa : {empresaDetails.nombre_empresa}
                        </p>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                {[
                                    { label: "Nombre Empresa", name: "nombre_empresa" },
                                    { label: "Razón Social", name: "razon_social" },
                                    { label: "Cédula Jurídica", name: "cedula_juridica" },
                                    { label: "Página Web", name: "pagina_web" },
                                    { label: "Teléfono", name: "telefono" },
                                    { label: "País", name: "pais" },
                                    { label: "Industria", name: "industria" },
                                ].map(({ label, name }) => (
                                    <div key={name} className="col-sm-6">
                                        <label>{label}:</label>
                                        <input type="text" name={name} value={empresaData[name]} onChange={handleInputChange} className={`form-control mb-2 ${errors[name] ? "is-invalid" : ""}`} />
                                        {errors[name] && <div className="invalid-feedback">{errors[name]}</div>}
                                    </div>
                                ))}
                                <div className="col-sm-6">
                                    <label>Dirección Física:</label>
                                    <textarea name="direccion_fisica" value={empresaData.direccion_fisica} onChange={handleInputChange} className={`form-control mb-2 ${errors.direccion_fisica ? "is-invalid" : ""}`}></textarea>
                                    {errors.direccion_fisica && <div className="invalid-feedback">{errors.direccion_fisica}</div>}
                                </div>
                                <div className="col-sm-6">
                                    <label>Tipo de Empresa:</label>
                                    <Select name="tipo_cliente" options={tipoClienteOptions} value={tipoClienteOptions.find((option) => option.value === empresaData.tipo_cliente) || null} onChange={handleSelectChange} className={`mb-2 ${errors.tipo_cliente ? "is-invalid" : ""}`} placeholder="Seleccione un tipo de cliente" />
                                    {errors.tipo_cliente && <div className="invalid-feedback">{errors.tipo_cliente}</div>}
                                </div>
                                <div className="col-sm-6">
                                    <label>¿Tiene Crédito?</label>
                                    <Select name="tiene_credito" options={tieneCreditoOptions} value={tieneCreditoOptions.find((option) => option.value === empresaData.tiene_credito) || null} onChange={handleSelectChange} className={`mb-2 ${errors.tiene_credito ? "is-invalid" : ""}`} />
                                    {errors.tiene_credito && <div className="invalid-feedback">{errors.tiene_credito}</div>}
                                </div>
                                <div className="col-sm-12">
                                    <label>Notas Importantes:</label>
                                    <textarea name="notas_importantes" value={empresaData.notas_importantes} onChange={handleInputChange} className="form-control mb-2"></textarea>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-primary mt-3">
                                Editar Empresa
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
